import { createFileRoute, redirect } from '@tanstack/react-router'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { propertyByIdQueryOptions } from '@/core/components/sites/propertyQueryOptions'
import { Role } from '@/core/components/auth/auth.types'
import { getConnections } from '@/core/components/sites/site/site-customization/manage-site/advanced-tab/connectivityQueryOptions'
import {
  getConnectedProviders,
  getProviders,
} from '@/core/components/sites/site/site-customization/manage-site/advanced-tab/paymentQueryOptions'

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/site-customization/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
    // Prefetch only: ConnectivityProvidersForm renders its own error state, so a
    // failure here must not reject the loader nor leak as an unhandled rejection.
    const connections = queryClient
      .ensureQueryData(getConnections(siteId, auth.token!))
      .catch(() => null)
    const property = queryClient.ensureQueryData(
      propertyByIdQueryOptions(siteId, auth.token!)
    )
    const connectedProviders = queryClient.ensureQueryData(
      getConnectedProviders(siteId, auth.token!)
    )
    const providers = queryClient.ensureQueryData(getProviders())
    return { connections, property, connectedProviders, providers }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
